import { useCallback } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const SuccessfullyDunnedPaymentAlert = ({
  successfullyDunnedPaymentObjectId
}) => {
  const sendCrmMessageTopic = useSendCrmMessageTopic('PREVIEW_OBJECT');
  const handleClick = useCallback(() => {
    sendCrmMessageTopic({
      objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
      objectId: String(successfullyDunnedPaymentObjectId)
    });
  }, [sendCrmMessageTopic, successfullyDunnedPaymentObjectId]);
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardPaymentHighlight.paymentHighlight.SuccessfullyDunnedPaymentAlert_jsx",
      options: {
        use: 'link',
        onClick: handleClick
      },
      elements: {
        Button
      }
    })
  });
};
export default SuccessfullyDunnedPaymentAlert;